var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c("input", {
      attrs: { type: "hidden", name: _vm.field.fieldName },
      domProps: { value: _vm.field.value },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }